import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { internalReturnPath, locationReturnPath, saveAppReturnPath, storedAppReturnPath } from '../auth/returnPath';

type AppLoginOptions = {
  returnTo?: string;
  message?: string;
  forceRedirect?: boolean;
};

export function useAppLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  return useCallback((options?: AppLoginOptions) => {
    const returnTo = internalReturnPath(options?.returnTo)
      ?? locationReturnPath(location)
      ?? internalReturnPath(location.state?.returnTo)
      ?? storedAppReturnPath()
      ?? '/profile';
    saveAppReturnPath(returnTo);
    navigate('/login', { state: { ...options, returnTo } });
  }, [location, navigate]);
}
